export const translateText = (str: string): string => (window.Transifex?.live.translateText(str)) || str;

export const normalizeText = (str: string ): string => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
